<ng-container *t="let t">
  <div [ngClass]="{'document-three-item-section': !isOnboarding, 'document-two-item-section': isOnboarding}">
    <div *ngIf="!isOnboarding">
      <div i18n="@@3264001515130844663" t="3264001515130844663">Document Type</div>
    </div>
    <div class="document-type-header">
      <div *ngIf="isOnboarding" i18n="@@PrimaryContactForm" t="PrimaryContactForm">
        Primary Contact Form
      </div>
      <div *ngIf="!isOnboarding" i18n="@@Document" t="Document">
        Document
      </div>
    </div>
    <div>
      <div i18n="@@be3404953dc2c57a9f7c45fe9268abc42c5b6334" t="be3404953dc2c57a9f7c45fe9268abc42c5b6334">Sign Date
      </div>
    </div>
  </div>
  <div [formGroup]="documentsFormArray">
    <div [formGroupName]="i" class="document-three-item-section" *ngFor="let docItem of documents; let i = index">
      <div style="padding-top: 14px;">
         <div *ngIf="!docItem?.IsOptionalList">{{ !isOnboarding ? translate.get(docItem?.DocumentTypeDescription) : ''}} <span
            *ngIf="disableValidations == true || docItem?.IsOptional == true" i18n="@@5878305334612867800"
            t="5878305334612867800">(optional)</span></div>
        <div *ngIf="docItem?.DocumentTypeDescription?.includes('Non-Disclosure Agreement')">
          <div class="my-0">
            <strong i18n="@@ba097ecce2dc3aeaf236f762938d8c8c4748c59a"
              t="ba097ecce2dc3aeaf236f762938d8c8c4748c59a">Note:</strong>
            <span i18n="@@d8a35be7409a18dca0132605a3cc914e2359b619" t="d8a35be7409a18dca0132605a3cc914e2359b619">NDA’s
              must be signed by both parties before being uploaded.
              The onboarding request will be routed back to you if the NDA is incomplete.
              Please work with your Tesla contact to obtain any missing signatures.</span>
          </div>
        </div>
        <div *ngIf="docItem?.DocumentType == 'PCF'">
          <div class="my-0">
            <strong i18n="@@ba097ecce2dc3aeaf236f762938d8c8c4748c59a"
              t="ba097ecce2dc3aeaf236f762938d8c8c4748c59a">Note:</strong>
            <span i18n="@@2756124417860424866" t="2756124417860424866">The organization’s Primary Contact will be the
              main point of contact for Tesla.
              This contact is responsible for managing contacts for your organization’s use of the Supplier Portal
              and in future uses on the portal have profile standards to uphold, finance detail access, and other
              critical data access.
              They are their organization’s primary authorizer for all issues/contacts.</span>
          </div>
        </div>
      </div>
      <div style="padding-top: 14px;">
        <!-- IF document has ID, then it has been uploaded. Display download button and remove button. -->
        <div *ngIf="docItem?.DocumentID">
          <a href="javascript:void(0)" (click)="downloadDocument(docItem)" class="break-all">
            {{ docItem?.FileName }}
          </a>
          <span style="padding-left: 25px;" *ngIf="!readOnly">
            <a class="link" tslTooltip="Click here to remove document" (click)="removeDocument(i)">
              <tsl-icon class="tsl-24">close</tsl-icon>
            </a>
          </span>
        </div>

        <!-- IF document doesn't have ID and it's an eSign document that can't be signed, display status of the signature -->
        <div *ngIf="!IsEsignAllowed(docItem?.FormGroup) && docItem?.ESignAgreementId && !docItem?.DocumentID">
          <a class="link" *ngIf="docItem?.ESignAgreementStatus != 'SIGNED' && !isTabStatusSubmitted"
            (click)="openEsignDocument(docItem?.ESignAgreementId)"
            tooltip="On click of this link, E-Sign page will open in a popup window. Please ensure popup is allowed for this website."
            i18n-tooltip="@@8265525825470393636" #esignLink tslTooltip="{{ t('8265525825470393636', esignLink) }}">
            <span i18n="@@a84e7d440f86f695b551728b3e78597b74dffa01" t="a84e7d440f86f695b551728b3e78597b74dffa01">Click
              here to E-Sign document</span>
            <tsl-icon>open_in_new</tsl-icon>
          </a>
          <div>
            <label><b i18n="@@17d7af030707b5bdf0145619ea5f6bb5fdbfd8af"
                t="17d7af030707b5bdf0145619ea5f6bb5fdbfd8af">E-Sign Status:
              </b></label><label>{{docItem?.ESignAgreementStatus}}</label>
          </div>
        </div>

        <!-- IF document doesn't have ID and is an 'upload' document, display button to upload file -->
        <div class="document-upload-container" *ngIf="!docItem?.DocumentID && IsUploadAllowed(docItem)">
          <button type="button" tsl-button color="blue" (click)="uploadFilePopUp(docItem)" class="width-150"
            [disabled]="isTabStatusSubmitted" i18n="@@4b3972c3e9485218508a95f7a4ce7758e3f09ced"
            t="4b3972c3e9485218508a95f7a4ce7758e3f09ced" tooltip="Click here to upload document"
            i18n-tooltip="@@313498405254693011" #uploadButton
            tslTooltip="{{ t('313498405254693011', uploadButton) }}">Upload</button>
          <span *ngIf="IsDownloadTemplateAvailable(docItem)">
            <button style="padding: 0;" tsl-button appearance="ghost" type="button" tsl-raised-button color="blue"
              (click)="downloadTemplate(docItem)" i18n="@@7d8617ef9679c6801a9e321efef9bde7f4dcf0d7"
              t="7d8617ef9679c6801a9e321efef9bde7f4dcf0d7" tooltip="Click here to download Template"
              i18n-tooltip="@@1949153665797005615" #downloadButton
              tslTooltip="{{ t('1949153665797005615', downloadButton) }}">Download Template</button>
          </span>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'DocumentID')" class="text-error">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('Document', docItem?.FormGroup?.get('DocumentID')) }}
            </tsl-error>
          </div>
        </div>

        <!-- Display button to eSign document -->
        <div *ngIf="IsEsignAllowed(docItem)">
          <div *ngFor="let template of docItem?.Templates;">
            <button type="button" tsl-button color="blue" [disabled]="isTabStatusSubmitted"
              (click)="publishForESign(docItem, template)" i18n="@@7456624093256824485" t="7456624093256824485"
              tooltip="Click here to E-Sign document" i18n-tooltip="@@a84e7d440f86f695b551728b3e78597b74dffa01"
              #esignDocumentButton
              tslTooltip="{{ t('a84e7d440f86f695b551728b3e78597b74dffa01', esignDocumentButton) }}">
              E-Sign
            </button>
          </div>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'ESignAgreementId')">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('E-Sign', docItem?.FormGroup?.get('ESignAgreementId')) }}
            </tsl-error>
          </div>
        </div>
      </div>
      <div>
        <tsl-form-field class="w-100">
          <tsl-datepicker [formControl]="docItem?.FormGroup?.get('SignedDate')" singleSelection [disabled]="readOnly"
            [selectYear]="true" [readonly]="true">
          </tsl-datepicker>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'SignedDate')">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('Sign Date', docItem?.FormGroup?.get('SignedDate')) }}
            </tsl-error>
          </div>
        </tsl-form-field>
      </div>
    </div>
  </div>
  <div [formGroup]="optionalListDocumentFormArray">
    <div [formGroupName]="i" class="document-three-item-section" *ngFor="let docItem of optionalDocuments; let i = index">
      <div>
        <tsl-form-field class="w-100">
          <tsl-select placeholder="Document Types" tPlaceholder="DocumentTypeList" i18n-placeholder="@@DocumentTypeList"  formControlName="DocumentType" name="DocumentType" (selectionChange)="onDocumentTypeChange(i, docItem?.FormGroup?.get('DocumentType')?.value)">
              <tsl-option *ngFor="let option of docItem?.DocumentTypeList" [value]="option.DocumentType">
                  {{translate.get(option?.DocumentTypeDescription)}}
              </tsl-option>
          </tsl-select>
          <tsl-error *ngIf="docItem?.FormGroup?.get('DocumentType')?.errors && (docItem?.FormGroup?.get('DocumentType')?.dirty || docItem?.FormGroup?.get('DocumentType')?.touched)">
            <span>{{translate.get('Please select a valid option from document list.')}}</span>
        </tsl-error>
      </tsl-form-field>
      </div>
      <div style="padding-top: 14px;">
        <!-- IF document has ID, then it has been uploaded. Display download button and remove button. -->
        <div *ngIf="docItem?.DocumentID">
          <a href="javascript:void(0)" (click)="downloadDocument(docItem)" class="break-all">
            {{ docItem?.FileName }}
          </a>
          <span style="padding-left: 25px;" *ngIf="!readOnly">
            <a class="link" tslTooltip="Click here to remove document" (click)="removeDocument(i, true)">
              <tsl-icon class="tsl-24">close</tsl-icon>
            </a>
          </span>
        </div>

        <!-- IF document doesn't have ID and it's an eSign document that can't be signed, display status of the signature -->
        <div *ngIf="!IsEsignAllowed(docItem?.FormGroup) && docItem?.ESignAgreementId && !docItem?.DocumentID">
          <a class="link" *ngIf="docItem?.ESignAgreementStatus != 'SIGNED' && !isTabStatusSubmitted"
            (click)="openEsignDocument(docItem?.ESignAgreementId)"
            tooltip="On click of this link, E-Sign page will open in a popup window. Please ensure popup is allowed for this website."
            i18n-tooltip="@@8265525825470393636" #esignLink tslTooltip="{{ t('8265525825470393636', esignLink) }}">
            <span i18n="@@a84e7d440f86f695b551728b3e78597b74dffa01" t="a84e7d440f86f695b551728b3e78597b74dffa01">Click
              here to E-Sign document</span>
            <tsl-icon>open_in_new</tsl-icon>
          </a>
          <div>
            <label><b i18n="@@17d7af030707b5bdf0145619ea5f6bb5fdbfd8af"
                t="17d7af030707b5bdf0145619ea5f6bb5fdbfd8af">E-Sign Status:
              </b></label><label>{{docItem?.ESignAgreementStatus}}</label>
          </div>
        </div>

        <!-- IF document doesn't have ID and is an 'upload' document, display button to upload file -->
        <div class="document-upload-container" *ngIf="!docItem?.DocumentID && IsUploadAllowed(docItem)">
          <button type="button" tsl-button color="blue" (click)="uploadOptionalFilePopUp(docItem)" class="width-150"
            [disabled]="isTabStatusSubmitted" i18n="@@4b3972c3e9485218508a95f7a4ce7758e3f09ced"
            t="4b3972c3e9485218508a95f7a4ce7758e3f09ced" tooltip="Click here to upload document"
            i18n-tooltip="@@313498405254693011" #uploadButton
            tslTooltip="{{ t('313498405254693011', uploadButton) }}">Upload</button>
          <span *ngIf="IsDownloadTemplateAvailable(docItem)">
            <button style="padding: 0;" tsl-button appearance="ghost" type="button" tsl-raised-button color="blue"
              (click)="downloadTemplate(docItem)" i18n="@@7d8617ef9679c6801a9e321efef9bde7f4dcf0d7"
              t="7d8617ef9679c6801a9e321efef9bde7f4dcf0d7" tooltip="Click here to download Template"
              i18n-tooltip="@@1949153665797005615" #downloadButton
              tslTooltip="{{ t('1949153665797005615', downloadButton) }}">Download Template</button>
          </span>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'DocumentID')" class="text-error">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('Document', docItem?.FormGroup?.get('DocumentID')) }}
            </tsl-error>
          </div>
        </div>

        <!-- Display button to eSign document -->
        <div *ngIf="IsEsignAllowed(docItem)">
          <div *ngFor="let template of docItem?.Templates;">
            <button type="button" tsl-button color="blue" [disabled]="isTabStatusSubmitted"
              (click)="publishForESign(docItem, template)" i18n="@@7456624093256824485" t="7456624093256824485"
              tooltip="Click here to E-Sign document" i18n-tooltip="@@a84e7d440f86f695b551728b3e78597b74dffa01"
              #esignDocumentButton
              tslTooltip="{{ t('a84e7d440f86f695b551728b3e78597b74dffa01', esignDocumentButton) }}">
              E-Sign
            </button>
          </div>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'ESignAgreementId')">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('E-Sign', docItem?.FormGroup?.get('ESignAgreementId')) }}
            </tsl-error>
          </div>
        </div>
      </div>
      <div>
        <tsl-form-field class="w-100">
          <tsl-datepicker [formControl]="docItem?.FormGroup?.get('SignedDate')" singleSelection [disabled]="readOnly"
            [selectYear]="true" [readonly]="true">
          </tsl-datepicker>
          <div *ngIf="isFieldInvalid(docItem?.FormGroup,'SignedDate')">
            <tsl-error class="text-left my-1">
              {{ getValidationMessages('Sign Date', docItem?.FormGroup?.get('SignedDate')) }}
            </tsl-error>
          </div>
        </tsl-form-field>
      </div>
    </div>
  </div>
</ng-container>